module.exports = __webpack_public_path__ + "img/iding-logo.a9d9c4a0.svg";